import { useQuery } from '@tanstack/react-query';
import { headlessGet } from '../lib/api';

interface RedirectRule {
  toPath: string;
  type: '301' | '302';
}

async function fetchRedirect(path: string): Promise<RedirectRule | null> {
  try {
    return await headlessGet<RedirectRule>(`/redirects?path=${encodeURIComponent(path)}`);
  } catch (err) {
    if ((err as Error & { status?: number }).status === 404) return null;
    return null;
  }
}

export function useRedirect(path: string) {
  return useQuery({
    queryKey: ['redirect', path],
    queryFn: () => fetchRedirect(path),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
